import { instanceForBackend } from '../../config/axios.config';
import { BACKEND_API } from '../../constants/backendApi';
export var shopService = {
    getShops: function () { return instanceForBackend.get(BACKEND_API.SHOPS); },
    createShop: function (data) { return instanceForBackend.post(BACKEND_API.SHOPS, data); },
    updateShop: function (data, id) {
        return instanceForBackend.put("".concat(BACKEND_API.SHOPS, "/").concat(id), data);
    },
    deleteShop: function (id) { return instanceForBackend.delete("".concat(BACKEND_API.SHOPS, "/").concat(id)); },
};
